import React, {useState, useEffect} from "react";
import "./boutique-page.css";
import {useHistory} from "react-router-dom";
import {connect} from "react-redux";
import {getCategoriesProduitsBoutique, getProduitPrix, getProducts, searchProducts, getCatalogueImage, getQuantiteEnMain} from "../../server/services/catalogue-service";
import Pagination from '../pagination/pagination.js';
import BoutiqueCard from "./boutique-card.js";
import FilterLeftPanel from "./filter-left-panel";
import FacturePanierPopup from "../popups/facture-panier-popup";
import {setSeoTitle} from "../../utils/document";
import LoadingSvg from "../svg/loading.js";
import DemanderProduitPrix from "./demander-produit-prix";
import {getQuantiteTempByIdProduit} from "../../server/services/reservation-service";

function BoutiquePage(props) {
    const history = useHistory();
    const [state, setState] = useState({
        categoriesLoaded: false, categories: [], items: [], itemsPerPage: 8, currentPage: 1, showSortPanel: false, isOpen: false, refresh: false, showPaginationMinimum: false, idFilteredProducts: []
    });
    const [isPopupProduitPrixOpen, setPopupProduitPrixOpen] = useState(false);
    const [selected, setSelected] = useState(null);
    const [forceRefresh, setForceRefresh] = useState(false)

    useEffect(async () => {
        setSeoTitle(props.entrepriseName, "Boutique");
        Promise.allSettled([getCategoriesProduitsBoutique(), getProducts(JSON.stringify({ListIdCategorieProduit: []}))]).then(([categoriesResult, allProductsResult]) => {
            if (categoriesResult.status !== 'fulfilled') return;
            const categories = categoriesResult.value;
            const search = decodeURI(history.location.search);
            const idFilteredProducts = [];
            if (categories.length) categories.forEach(el => {
                el['checked'] = search.includes(el.description);
                if (el.checked) idFilteredProducts.push(el.idProduitCategorie);
            })
            let visibleCategories = categories;
            if (allProductsResult.status === 'fulfilled') {
                const categoryIdsWithProducts = new Set(allProductsResult.value.map(p => p.idProduitCategorie));
                visibleCategories = visibleCategories.filter(c => categoryIdsWithProducts.has(c.idProduitCategorie));
            }
            visibleCategories = visibleCategories.filter(c => c.idProduitCategorie !== '00000000-0000-0000-0000-000000000000');
            setState(prevState => ({
                ...prevState, idFilteredProducts: idFilteredProducts, categories: visibleCategories, categoriesLoaded: true
            }));
        })
    }, [])

    useEffect(async () => {
        if (state.categoriesLoaded && state.idFilteredProducts) {
            const post = JSON.stringify({
                ListIdCategorieProduit: state.idFilteredProducts?.length ? state.idFilteredProducts : []
            })
            try {
                const catalogue = await getProducts(post);
                const catalogueWithImages = await Promise.all(catalogue.map(async (product) => {
                    if (product.idProduit) {
                        const prix = await getProduitPrix(product.idProduit);
                        product.produitPrix = prix;

                        const img = await getCatalogueImage(product.idProduit);
                        if (img?.[0]) {
                            product.img = `data:image/jpeg;base64,${ img[0].image }`;
                        }

                        const quantiteEnMain = await getQuantiteEnMain(product.idProduit)
                        const quantitePanier = await getQuantiteTempByIdProduit(product.idProduit);
                        product.quantiteEnMain = quantiteEnMain - quantitePanier;
                    }
                    return product;
                }));

                setState(prevState => ({
                    ...prevState, catalogue: catalogueWithImages, totalItems: catalogueWithImages.length, pages: Math.ceil(catalogueWithImages.length / 8), items: catalogueWithImages.slice(0, 8), dataLoaded: true
                }));
            } catch (error) {
                // console.log(error);
            }

        }
    }, [state.categoriesLoaded, state.idFilteredProducts])

    const applyFilter = (filteredCategoryIds = []) => {
        setState(prevState => ({
            ...prevState, idFilteredProducts: filteredCategoryIds, items: [], dataLoaded: false,
        }));
    }
    useEffect(async () => {
        try {
            const product = await Promise.all((state.catalogue || []).map(async (product) => {
                if (product.idProduit) {
                    const quantiteEnMain = await getQuantiteEnMain(product.idProduit)
                    const quantitePanier = await getQuantiteTempByIdProduit(product.idProduit);
                    product.quantiteEnMain = quantiteEnMain - quantitePanier;
                }
                return product;
            }));

            setState(prevState => ({
                ...prevState, catalogue: product
            }));
        } catch (error) {
            //console.log(error);
        }


    }, [props.shop.cart, forceRefresh]);

    const handleClose = () => {
        setState({
            ...state, isOpen: false
        });
    };

    const changePage = (page) => {
        setState(prevState => ({
            ...prevState, currentPage: page, items: prevState.catalogue.slice((page - 1) * 8, page * 8)
        }))
        window.scrollTo(0, 800)
    }

    const showPagination = state.dataLoaded && !props.showPaginationMinimum && state.catalogue.length > 0 && (!props.showPaginationMinimum || (state.totalItems != null && state.totalItems >= 8));

    const Page = showPagination ? <Pagination
        pages={ state.pages }
        totalItems={ state.totalItems }
        currentTotalItems={ state.items.length }
        currentPage={ state.currentPage }
        changePage={ changePage }
    /> : null

    return (<div className="container-boutique nopadding">
        <div className="container-boutique products-grid position-relative grid-toggle">
            { selected && <DemanderProduitPrix
                selected={ selected }
                setSelected={ setSelected }
                isOpen={ selected }
                onAddUpdateShoppingCart={ props.onAddUpdateShoppingCart }
                handleClose={ () => {
                    setPopupProduitPrixOpen(false);
                    setSelected(null);
                } }
            /> }
            <div className="ais-page">

                <FilterLeftPanel
                    showByType='boutique'
                    totalItems={ state.totalItems }
                    applyFilter={ applyFilter }
                    categories={ state.totalItems > 0 ? state.categories : [] }
                    getProducts={ () => {
                    } }
                />

                <FacturePanierPopup
                    showByType='boutique'
                    handleClose={ handleClose }
                    isOpen={ state.isOpen }
                />

                <div className="ais-block">
                    <div className={ `${ !state.showSortPanel && 'ais-search-header' } desktop-only` }>
                        <div className="ais-sort">
                            <span className="ais-sort-orders-container">
                                  <select className="ais-SortBy-select">
                                    <option value="shopify_products">
                                      TRIER
                                    </option>
                                    <option value="shopify_products_price_asc">
                                      Price: Low to High
                                    </option>
                                    <option value="shopify_products_price_desc">
                                      Price: High to Low
                                    </option>
                                    <option value="shopify_products_title_asc">
                                      Name: A to Z
                                    </option>
                                    <option value="shopify_products_title_desc">
                                      Name: Z to A
                                    </option>
                                    <option value="shopify_products_ratings_desc">
                                      Customer Rating
                                    </option>
                                  </select>
                                </span>
                        </div>
                    </div>
                    { Page }
                    <div className="ais-results-as-block">
                        <div className="ais-hits">
                            { state.items.length ? state.items.map((card, index) => (<BoutiqueCard
                                key={ index }
                                showSmallCardTitle={ props.showSmallCardTitle }
                                onClick={ props.onClick }
                                openPopup={ () => {
                                    setPopupProduitPrixOpen(true)
                                } }
                                card={ card }
                                setSelected={ setSelected }
                                onAddUpdateShoppingCart={ props.onAddUpdateShoppingCart }
                                refresh={ () => setForceRefresh(prev => !prev) }
                            />)) : <span className="boutique-page-no-result">
                    { state.dataLoaded ? <h2>AUCUN RÉSULTAT TROUVÉ</h2> : <h2><LoadingSvg background={ props.backgroundSvgColor }/> CHARGEMENT DES DONNÉES…</h2> }
                  </span> }
                        </div>
                    </div>
                    { Page }
                </div>
            </div>
        </div>
    </div>)
}

BoutiquePage.defaultProps = {
    backgroundSvgColor: "rgb(255, 255, 255)"
}
const mapStateToProps = (state, ownProps) => ({
    shop: state.shop, entrepriseName: state.entreprise.nom
});
export default connect(mapStateToProps)(BoutiquePage);